import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import Button from '@amzn/meridian/button'
import Column from '@amzn/meridian/column'
import { AtHeader } from '@amzn/ihm-associate-tools-meridian-components'
import { EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'

import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'

import { StoreIdService } from '@src/pages/StoreIdSelection/utils/StoreIdService'
import { IhmLoginServiceClient } from '@src/api/IhmLoginServiceClient'
import { IIBServiceClient } from '@src/api/IIBServiceClient'
import { IhmLoginTokenProvider } from '@api/utils/IhmLoginTokenProvider'
import { IIBTokenProvider } from '@api/utils/IIBTokenProvider'
import { UserTypeService } from '@pages/UserTypeSelection/utils/UserTypeService'
import ATLoader from '@src/components/ATLoader'

const StoreIdSelectionPage = () => {
    const navigate = useNavigate()
    const stores = StoreIdService.getAvailableStoresForUser()

    const [bundle, isBundleLoading] = useBundle(BUNDLE_NAME)

    const setStoreId = (storeId: string) => {
        console.debug('Setting storeId', storeId)
        try {
            StoreIdService.setSelectedStoreId(storeId)
            if (EnvironmentDetail.isIIBAuthN()) {
                IIBTokenProvider.clear()
                IhmLoginTokenProvider.clear()
                UserTypeService.resetIsWfmLogin()
                IIBServiceClient.login()
            } else {
                navigate('/provision')
            }
        } catch (error) {
            console.log('ATBase: Exception occurred while setting selected store, redirecting to user-type-selection. Exception:', error)
            navigate('/user-type-selection')
        }
    }

    useEffect(() => {
        if (stores.length === 1) {
            setStoreId(stores[0].storeId)
        }
    }, [])

    const storeButtons = []

    stores.map((store) => {
        storeButtons.push(
            <Button onClick={() => { setStoreId(store.storeId) }}>{store.storeId} ({store.warehouseId})</Button>,
        )
    })

    if (isBundleLoading) {
        return <ATLoader />
    }

    return (
        <>
            <Column spacing={'medium'}>
                <AtHeader title={t(bundle, 'ihm-associatetoolsbase-select-store')} goBack={() => { return }}/>
                <Column spacingInset="medium">
                    {storeButtons}
                </Column>
            </Column>
        </>
    )
}

export default StoreIdSelectionPage
